<template>
  <div class="chart-container">
    <Doughnut :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { getSiteColor } from '@/constants/siteColors';

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  name: 'DonutChartWebsites',
  components: { Doughnut },
  props: {
    platformSales: {
      type: Object,
      required: true
    },
    height: {
      type: [Number, String],
      default: 150 // Default height for compact layout
    }
  },
  computed: {
    chartData() {
      const platforms = ['Flirt4Free', 'Streamate', 'LiveJasmin', 'Chaturbate', 'StripChat', 'Kwiky', 'Sin Party', 'Cams', 'Cam4', 'Bonga'];
      const data = [
        this.platformSales.flirt4free || 0,
        this.platformSales.streamate || 0,
        this.platformSales.livejasmin || 0,
        this.platformSales.chaturbate || 0,
        this.platformSales.stripchat || 0,
        this.platformSales.kwiky || 0,
        this.platformSales.sinparty || 0,
        this.platformSales.cams || 0,
        this.platformSales.cam4 || 0,
        this.platformSales.bonga || 0
      ];
      return {
        labels: platforms,
        datasets: [
          {
            data: data,
            backgroundColor: platforms.map(platform => getSiteColor(platform)),
            borderColor: platforms.map(platform => getSiteColor(platform)),
            borderWidth: 1
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false // Remove the legend (platform labels)
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const label = context.label || '';
                const value = context.raw || 0;
                return `${label}: $${value.toFixed(2)}`;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: v-bind(height + 'px'); /* Use the height prop dynamically */
  width: 100%;
}
</style>
